// removed by extract-text-webpack-plugin
module.exports = {"shareBox":"styles__shareBox__17PCD","title":"styles__title__2zMp2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareBox/styles.scss
// module id = 902
// module chunks = 0